import { useEffect, useMemo, useState } from 'react';
import { useReport } from 'core/contexts/reports';
import { useTranslation } from 'react-i18next';
import { Box, Grid2, Tab, Tabs } from '@mui/material';
import { Title } from '@utriper/core-ui';
import Layout from 'components/Layout';
import HostReport from './components/HostReport';
import BookingTab from './components/BookingTab';
import ReportFilter from './components/ReportFilter';
import { useStyles } from './styles';

const ReportsPage = () => {
    const { getHostReports } = useReport();
    const { t } = useTranslation();
    const translate = (key) => t(`reports.${key}`);
    const classes = useStyles();

    const DETAIL_VIEW = useMemo(
        () => ({
            OVERVIEW: 'overview',
            BOOKINGS: 'bookings',
        }),
        []
    );
    const [detailView, setDetailView] = useState(DETAIL_VIEW.OVERVIEW);

    useEffect(() => {
        getHostReports();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDetailTabChange = (_e, newValue) => setDetailView(newValue);

    return (
        <Layout>
            <Box
                component="section"
                sx={{
                    padding: '32px',
                    width: '100%',
                    justifySelf: 'center',
                    boxSizing: 'border-box',
                }}>
                <Grid2 container width="100%" direction="column" justifyContent="center" alignItems="flex-start" gap="16px" sx={{ color: '#131313' }}>
                    <Title value={translate('title')} />
                </Grid2>

                <Grid2 container display={'flex'} width={'full'} size={12} marginBlock={1}>
                    <ReportFilter />
                </Grid2>

                <Grid2 container width="100%" justifyContent="flex-start" alignItems="center" mb={2}>
                    <Tabs value={detailView} onChange={handleDetailTabChange} aria-label="report-detail-tabs" className={classes.tab}>
                        <Tab value={DETAIL_VIEW.OVERVIEW} label={translate('overview_tab')} sx={{ fontWeight: 'bold' }} />
                        <Tab value={DETAIL_VIEW.BOOKINGS} label={translate('bookings_tab')} sx={{ fontWeight: 'bold' }} />
                    </Tabs>
                </Grid2>

                {detailView === DETAIL_VIEW.OVERVIEW ? <HostReport /> : detailView === DETAIL_VIEW.BOOKINGS ? <BookingTab /> : ''}
            </Box>
        </Layout>
    );
};

ReportsPage.displayName = 'ReportsPage';

export default ReportsPage;
